export const FiltroUsuariosPagosPendientesMax = 10; //total del random
export const limiteUsuariosPagosPendientes = 10; //cantidad de usuarios habilitados del total - actualmente al 100%
